







































import { defineComponent } from '@nuxtjs/composition-api';
import BaseButton from '@shared/components/@atoms/BaseButton/BaseButton.vue';
import BaseIcon from '@shared/components/@atoms/BaseIcon/BaseIcon.vue';
import BaseOverlay from '@shared/components/@atoms/BaseOverlay/BaseOverlay.vue';
import BaseBar from '@shared/components/@molecules/BaseBar/BaseBar.vue';
import { clickOutside, focusTrap } from '@shared/ui/utilities/directives';
import { isClient } from '@shared/ui/utilities/helpers';
// @ts-ignore migrated from ui-library
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';
export default defineComponent({
  name: 'BaseModal',
  directives: { focusTrap, clickOutside },
  components: {
    BaseBar,
    BaseOverlay,
    BaseIcon,
    BaseButton,
  },
  model: {
    prop: 'visible',
    event: 'close',
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    cross: {
      type: Boolean,
      default: true,
    },
    overlay: {
      type: Boolean,
      default: true,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    transitionModal: {
      type: String,
      default: 'sf-fade',
    },
  },
  data() {
    return {
      staticClass: null,
      className: null,
    };
  },
  watch: {
    visible: {
      handler: function (value) {
        if (!isClient) return;
        if (value) {
          this.$nextTick(() => {
            disableBodyScroll(this.$refs.content);
          });
          document.addEventListener('keydown', this.keydownHandler);
        } else {
          clearAllBodyScrollLocks();
          document.removeEventListener('keydown', this.keydownHandler);
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    clearAllBodyScrollLocks();
  },
  methods: {
    close() {
      this.$emit('close', false);
    },
    checkPersistence() {
      if (!this.persistent) {
        this.close();
      }
    },
    // @ts-ignore migrated from ui-library
    keydownHandler(e) {
      if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
        this.close();
      }
    },
    classHandler() {
      // @ts-ignore migrated from ui-library
      if (this.staticClass !== this.$vnode.data.staticClass) {
        // @ts-ignore migrated from ui-library
        this.staticClass = this.$vnode.data.staticClass;
      }
      // @ts-ignore migrated from ui-library
      if (this.className !== this.$vnode.data.class) {
        // @ts-ignore migrated from ui-library
        this.className = this.$vnode.data.class;
      }
    },
  },
});
